// src/services/axiosHandlers.ts
export let logoutHandler: () => void = () => {};
export let showWarningToastHandler: (message: string) => void = () => {};
export let navigateHandler: (path: string) => void = () => {};

export const setAxiosHandlers = ({
  logout,
  showWarningToast,
  navigate,
}: {
  logout: () => void;
  showWarningToast: (msg: string) => void;
  navigate: (path: string) => void;
}) => {
  logoutHandler = logout;
  showWarningToastHandler = showWarningToast;
  navigateHandler = navigate;
};
